import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard03 = () => {
  const productData = {
    titleJP: '六种野生灵芝+全破壁灵芝粉',
    titleEN: 'Specially added pure Wild Ganoderma ',
    subTitle: '全面改善身体机能 / Overall improvement of body function',
    descJP:
      '冠军野山灵芝萃取五种野生灵芝中最有效之多糖肽，融合全破壁灵芝孢子粉，既使六种野生灵芝中有效成份针对人体各部位发挥显著保健功效，又能将强效孢子粉提升机体抵抗力的功效发挥到极限。提取物中的蛋白质、多种维生素及十多种氨基酸作为膳食补充剂，有均衡人体机能的独特功效',
    descEN:
      'The Premium Wild Ganoderma extract features the most effective polysaccharide peptides from five varieties of wild Ganoderma lucidum, combined with finely ground full-wall broken spore powder. This powerful blend not only enables the beneficial ingredients from these wild Ganoderma varieties to deliver significant health benefits across various parts of the body but also maximizes the immune-boosting effects of the potent spore powder. Rich in proteins, a variety of vitamins, and over ten amino acids, this extract serves as a dietary supplement with a unique ability to balance bodily functions.',
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-3-1734075592408.png'
  }
  const benefitData = [
    {
      ratio: 608 / 686,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-mobile-3-1733133947030.png'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '50px',
        lg: '105px'
      }}
      pb="80px"
      gap={5}
      id="wild-ganoderma"
    >
      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0',
          lg: '-5%'
        }}
      >
        <AspectRatio
          ratio={1016 / 1408}
          w={{
            base: '100%',
            lg: '90%'
          }}
          ml="auto"
        >
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={1544 / 218}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-3-1733133504839.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>

          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} isOne />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-premium-wild-ganoderma-120s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>
    </Flex>
  )
}

export default ProductCard03
